import React from 'react';
import ReactDOM from 'react-dom';
import ListaResultadosColetados from "./ListaResultadosColetados";
import { toast, ToastContainer } from 'react-toastify';
import { Dropdown } from "primereact/dropdown";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {MultiSelect} from 'primereact/multiselect';
import {estados} from "../../util/estados";
import ModalIgnorar from "./ModalIgnorar";
import { Panel } from 'primereact/panel';
import ModalProcurarEmpreendimento from "../BuscaEmpreendimento/ModalProcurarEmpreendimento";


const BRAIN_COMPANY_ID = 31;

export default class ResultadosCidade extends React.Component {

    initialFiltersState = {
        estados: [],
        cidades: [],
        possivel_cadastro: '',
        lancamentos: '',
        data_coleta_maior_que: '',
        data_coleta_menor_que: '',
        ignorados: '',
        ignorado_por: [],
        data_ignorado_maior_que: '',
        data_ignorado_menor_que: '',
        empreendimento_cadastrado: '',
        cadastrado_por: [],
        data_cadastro_empreendimento_menor_que: '',
        data_cadastro_empreendimento_maior_que: '',
        ignorado_motivo: []
    }

    constructor(props) {
        super(props);

        this.state = {
            activeIndex: 0, loading: false, resultados: [], ignorados: [], filters: {
                ...this.initialFiltersState
            }, sim_nao_options: [{
                label: "Selecione", value: null,
            }, {
                label: "Sim", value: true,
            }, {
                label: "Não", value: false,
            },], estados_options: [], cidades_options: [], users_options: [], ignorado_motivos_options: [{
                label: "Duplicado", value: 'Duplicado',
            }, {
                label: "Imóvel Revenda", value: 'Imóvel Revenda',
            }, {
                label: "Dados Inválidos", value: 'Dados Inválidos',
            },

            ], show_modal_ignorar: false, coletaSelecionada: null, cidade_mapeamento: null,
            pagination: {
                current_page: 1, per_page: 30, total: 0, from: 0, to: 0
            },
            show_modal_procurar_empreendimento: false,
            busca_empreendimento_filters: {
                nome_cidade: [], estados: []
            }
        }
    }

    showModalIgnorarColeta = (coletaSelecionada) => {
        this.setState({
            ...this.state, show_modal_ignorar: true, coletaSelecionada: coletaSelecionada
        })
    }

    closeModalIgnorar = () => {
        this.setState({
            ...this.state, show_modal_ignorar: false
        })
    }

    componentDidMount = async () => {

        document.addEventListener("keydown", this.handleKeyDown);

        const mapeamentoId = route().params.id;

        if (mapeamentoId) {
            await this.setState({
                mapeamentoId: mapeamentoId,
            });

            await this.getCidadeMapeamento();
        }

        await Promise.all([this.getResultsCidade(), this.loadUsers()]);

    }

    handleKeyDown = async (event) => {
        if (event.ctrlKey && event.key === "k") {
            event.preventDefault();
            await this.openModalProcurarEmpreendimento();
        }
    }

    openModalProcurarEmpreendimento = async () => {
        await this.setState({
            ...this.state,
            show_modal_procurar_empreendimento: true
        })
    }

    closeModalProcurarEmpreendimento = async () => {
        await this.setState({
            ...this.state,
            show_modal_procurar_empreendimento: false
        })
    }

    openBuscaEmpreendimentoComFiltros = async (info) => {
        const event = new CustomEvent('setFilters', { detail: info });
        window.dispatchEvent(event);

        await this.openModalProcurarEmpreendimento();
    }

    getCidadeMapeamento = async () => {
        try {
            const response = await axios.get(route('web.cidade.mapeamento', this.state.mapeamentoId));

            let cidadeOptionValue = {
                label: response.data.cidade, value: response.data.cidade,
            }

            let estadoOptionValue = estados.find((estado) => {
                return estado.value === response.data.estado;
            });

            this.setState({
                ...this.state, cidade_mapeamento: response.data, filters: {
                    ...this.state.filters, cidades: [response.data.cidade], estados: [response.data.estado],
                }, cidades_options: [cidadeOptionValue],
            })
        } catch (error) {
            console.error(error);
        }

    }

    getResultsCidade = async () => {
        try {
            const mapeamentoId = route().params.id;

            let page = this.state.pagination.current_page;

            this.setLoading(true);

            let requestParams = {
                ...this.state.filters,
                page: page,
                per_page: this.state.pagination.per_page,
            };

            if (mapeamentoId) {
                requestParams["id"] = mapeamentoId;
            }

            let requestExtraParams = {};

            if (this.state.filters.export_excel) {
                requestExtraParams.responseType = 'blob';
            }

            const response = await axios.get(route('coletas.automatizadas.resultados_cidade_json', requestParams), requestExtraParams);


            if (response.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                this.handleDownloadExcel(response);
                return;
            }

            let resultados = response.data.data;



            await this.setState({
                ...this.state, resultados: resultados,
                pagination: {
                    current_page: response.data.current_page,
                    per_page: response.data.per_page,
                    total: response.data.total,
                    from: response.data.from,
                    to: response.data.to
                }
            })

        } catch (e) {
            console.error(e);
        } finally {
            this.setLoading(false);
        }
    }

    handleDownloadExcel(response) {
        const type = response.headers['content-type']
        const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = response.headers['content-disposition'].split(';')[1].split('=')[1];
        link.click()

        this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                export_excel: false
            }
        });

    }

    ignoreColeta = async ({ id, motivo, link }) => {
        try {

            await this.setLoading(true);

            const response = await axios.post(route('web.workflow_data.ignore'), {
                id: id, motivo: motivo,
            });

            await axios.post('/log-detalhado', {
                link: link,
                status: "Ignorado",
                categoria: "IA",
                peso: 1,
            });

            await this.setState({
                ...this.state, ignorados: [...this.state.ignorados, response.data.hash]
            });

            await this.getResultsCidade();

            await this.closeModalIgnorar();

            toast("Resultado ignorado com sucesso!", {
                type: toast.TYPE.SUCCESS,
            });


        } catch (error) {
            console.log(error);

        } finally {
            this.setLoading(false);
        }
    }

    setLoading = (loading) => {
        this.setState({
            loading: loading
        })
    }

    cadastrarEmpreendimento = async (coleta) => {
        console.log(coleta);

        try {
            const response = await axios.post(route('web.workflow_cadastrar_empreendimento'), coleta);

            if (response.status === 200) {
                //abrir nova aba com o endereço
                window.open(response.data.redirect_url, '_blank');
            }
        } catch (e) {
            console.log(e);
        } finally {
            this.setLoading(false);
        }
    }

    handleEstadosChanged = async (e) => {
        await this.setState({
            ...this.state, filters: {
                ...this.state.filters, estados: e.target.value,
            }
        })

        await this.loadCidades();
    }

    loadCidades = async () => {
        try {
            this.setLoading(true);

            const response = await axios.get(route('web.municipios.index', {
                ufs: this.state.filters.estados,
            }));

            await this.setState({
                ...this.state, cidades_options: response.data,
            })

        } catch (error) {
            console.log(error);
        } finally {
            this.setLoading(false);
        }
    }

    loadUsers = async () => {
        try {
            this.setLoading(true);

            const response = await axios.get(route('web.company.users-combo', {
                company_id: BRAIN_COMPANY_ID,
            }));

            await this.setState({
                ...this.state, users_options: response.data,
            })

        } catch (error) {
            console.log(error);
        } finally {
            this.setLoading(false);
        }
    }

    handleCidadesChanged = async (e) => {
        this.setState({
            ...this.state, filters: {
                ...this.state.filters, cidades: e.target.value,
            }
        })
    }

    clearFilters = async (e) => {
        e.preventDefault();

        let cidades = [];
        let estados = [];
        if (this.state.cidade_mapeamento != null) {
            cidades = this.state.filters.cidades;
            estados = this.state.filters.estados;
        }

        await this.setState({
            ...this.state, filters: {
                estados: estados, cidades: cidades, ...this.initialFilters,
            }
        });

        await this.getResultsCidade();
    }

    handlePageChange = async (pageNumber) => {
        await this.setState({
            ...this.state, pagination: {
                ...this.state.pagination, current_page: pageNumber
            }
        });

        await this.getResultsCidade();
    }

    handlePerPageChanged = async (e) => {
        await this.setState({
            ...this.state, pagination: {
                ...this.state.pagination,
                per_page: e.target.value,
                current_page: 0
            }
        });

        await this.getResultsCidade();
    }

    render() {
        return (<React.Fragment>

            <ModalProcurarEmpreendimento
                visible={this.state.show_modal_procurar_empreendimento}
                onHide={this.closeModalProcurarEmpreendimento}
            />

            <ModalIgnorar
                options={this.state.ignorado_motivos_options}
                visible={this.state.show_modal_ignorar}
                onClose={this.closeModalIgnorar}
                onHide={this.closeModalIgnorar}
                ignorarColeta={this.ignoreColeta}
                coletaSelecionada={this.state.coletaSelecionada}
            />

            <div className="row">
                <div className="col-12">

                    <ToastContainer
                        position="top-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        style={{ width: "50%", zIndex: 9999999, fontWieght: 'bold' }}
                    />


                    <Panel header="Busca">
                        <div>
                            <div className="form-group row">
                                <div className="col-12 col-md-6 col-sm-6">
                                    <label htmlFor="estado">Estado</label> <br />
                                    <MultiSelect
                                        placeholder="Selecione os Estados"
                                        style={{ width: '100%' }}
                                        value={this.state.filters.estados}
                                        options={estados}
                                        display="chip"
                                        disabled={this.state.cidade_mapeamento != null}
                                        onChange={this.handleEstadosChanged}
                                        filter
                                    />
                                </div>

                                <div className="col-12 col-md-6 col-sm-6">
                                    <label htmlFor="cidade">Cidade</label> <br />
                                    <MultiSelect
                                        placeholder="Selecione as Cidades"
                                        style={{ width: '100%' }}
                                        value={this.state.filters.cidades}
                                        options={this.state.cidades_options}
                                        display="chip"
                                        onChange={this.handleCidadesChanged}
                                        disabled={this.state.cidade_mapeamento != null}
                                        filter
                                    />

                                </div>
                            </div>

                            <div className="form-group row">

                                <div className="col-12 col-md-3 col-sm-3">
                                    <label htmlFor="ignorados">Provável Empreendimento Existente</label> <br />
                                    <Dropdown
                                        value={this.state.filters.possivel_cadastro}
                                        options={this.state.sim_nao_options}
                                        style={{ width: '100%' }}
                                        onChange={(e) => {
                                            this.setState({
                                                ...this.state, filters: {
                                                    ...this.state.filters, possivel_cadastro: e.target.value,
                                                }
                                            })
                                        }} placeholder="Selecione" />
                                </div>

                                <div className="col-12 col-md-3 col-sm-3">
                                    <label htmlFor="ignorados">Prováveis Lançamentos</label> <br />
                                    <Dropdown
                                        value={this.state.filters.lancamentos}
                                        options={this.state.sim_nao_options}
                                        style={{ width: '100%' }}
                                        onChange={(e) => {
                                            this.setState({
                                                ...this.state, filters: {
                                                    ...this.state.filters, lancamentos: e.target.value,
                                                }
                                            })
                                        }} placeholder="Selecione" />
                                </div>

                                <div className="col-12 col-md-3 col-sm-3">
                                    <label htmlFor="">Data da Coleta Maior que:</label>
                                    <DatePicker
                                        locale="pt-BR"
                                        className="form-control"
                                        dateFormat="dd/MM/yyyy"
                                        selected={this.state.filters.data_coleta_maior_que}
                                        onChange={async (e) => {
                                            await this.setState({
                                                ...this.state, filters: {
                                                    ...this.state.filters, data_coleta_maior_que: e
                                                }
                                            });
                                        }}
                                    />
                                </div>

                                <div className="col-12 col-md-3 col-sm-3">
                                    <label htmlFor="">Data da Coleta Menor que:</label>
                                    <DatePicker
                                        locale="pt-BR"
                                        className="form-control"
                                        dateFormat="dd/MM/yyyy"
                                        selected={this.state.filters.data_coleta_menor_que}
                                        onChange={async (e) => {
                                            await this.setState({
                                                ...this.state, filters: {
                                                    ...this.state.filters, data_coleta_menor_que: e
                                                }
                                            });
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="row form-group">
                                <div className="col-12 col-md-2 col-sm-2">

                                    <label htmlFor="ignorados">Ignorados</label> <br />
                                    <Dropdown
                                        value={this.state.filters.ignorados}
                                        options={this.state.sim_nao_options}
                                        style={{ width: '100%' }}
                                        onChange={(e) => {
                                            this.setState({
                                                ...this.state, filters: {
                                                    ...this.state.filters, ignorados: e.target.value,
                                                }
                                            })
                                        }} placeholder="Selecione" />
                                </div>

                                <div className="col-12 col-md-2 col-sm-2">

                                    <label htmlFor="ignorados">Ignorado Por Motivo</label> <br />
                                    <MultiSelect
                                        value={this.state.filters.ignorado_motivo}
                                        options={this.state.ignorado_motivos_options}
                                        style={{ width: '100%' }}
                                        onChange={(e) => {
                                            this.setState({
                                                ...this.state, filters: {
                                                    ...this.state.filters, ignorado_motivo: e.target.value,
                                                }
                                            })
                                        }} placeholder="Selecione" />
                                </div>

                                <div className="col-12 col-md-2 col-sm-2">
                                    <label htmlFor="cidade">Ignorado Por:</label> <br />
                                    <MultiSelect
                                        style={{ width: '100%' }}
                                        value={this.state.filters.ignorado_por}
                                        options={this.state.users_options}
                                        placeholder="Selecione os usuários"
                                        display="chip"
                                        onChange={(e) => {
                                            this.setState({
                                                ...this.state, filters: {
                                                    ...this.state.filters, ignorado_por: e.target.value,
                                                }
                                            })
                                        }}
                                        filter
                                    />
                                </div>

                                <div className="col-12 col-md-3 col-sm-3">
                                    <label htmlFor="data_cadastro_maior_que">Ignorados na data maior que</label>
                                    <DatePicker
                                        locale="pt-BR"
                                        className="form-control"
                                        dateFormat="dd/MM/yyyy"
                                        selected={this.state.filters.data_ignorado_maior_que}
                                        onChange={async (e) => {
                                            await this.setState({
                                                ...this.state, filters: {
                                                    ...this.state.filters, data_ignorado_maior_que: e
                                                }
                                            });
                                        }}
                                    />
                                </div>

                                <div className="col-12 col-md-3 col-sm-3">
                                    <label htmlFor="data_cadastro_maior_que">Ignorados na data menor que</label>
                                    <DatePicker
                                        locale="pt-BR"
                                        className="form-control"
                                        dateFormat="dd/MM/yyyy"
                                        selected={this.state.filters.data_ignorado_menor_que}
                                        onChange={async (e) => {
                                            await this.setState({
                                                ...this.state, filters: {
                                                    ...this.state.filters, data_ignorado_menor_que: e
                                                }
                                            });
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-12 col-md-3 col-sm-3">
                                    <label htmlFor="ignorados">Empreendimento Cadastrado</label> <br />
                                    <Dropdown
                                        value={this.state.filters.empreendimento_cadastrado}
                                        options={this.state.sim_nao_options}
                                        style={{ width: '100%' }}
                                        onChange={(e) => {
                                            this.setState({
                                                ...this.state, filters: {
                                                    ...this.state.filters, empreendimento_cadastrado: e.target.value,
                                                }
                                            })
                                        }} placeholder="Selecione" />
                                </div>

                                <div className="col-12 col-md-3 col-sm-3">
                                    <label htmlFor="cidade">Cadastrado Por:</label> <br />
                                    <MultiSelect
                                        style={{ width: '100%' }}
                                        value={this.state.filters.cadastrado_por}
                                        options={this.state.users_options}
                                        placeholder="Selecione os usuários"
                                        display="chip"
                                        onChange={(e) => {
                                            this.setState({
                                                ...this.state, filters: {
                                                    ...this.state.filters, cadastrado_por: e.target.value,
                                                }
                                            })
                                        }}
                                        filter
                                    />
                                </div>

                                <div className="col-12 col-md-3 col-sm-3">
                                    <label htmlFor="data_cadastro_maior_que">Data de Cadastro maior que</label>
                                    <DatePicker
                                        locale="pt-BR"
                                        className="form-control"
                                        dateFormat="dd/MM/yyyy"
                                        selected={this.state.filters.data_cadastro_empreendimento_maior_que}
                                        onChange={async (e) => {
                                            await this.setState({
                                                ...this.state, filters: {
                                                    ...this.state.filters, data_cadastro_empreendimento_maior_que: e
                                                }
                                            });
                                        }}
                                    />
                                </div>

                                <div className="col-12 col-md-3 col-sm-3">
                                    <label htmlFor="data_cadastro_maior_que">Data de Cadastro menor que</label>
                                    <DatePicker
                                        locale="pt-BR"
                                        className="form-control"
                                        dateFormat="dd/MM/yyyy"
                                        selected={this.state.filters.data_cadastro_empreendimento_menor_que}
                                        onChange={async (e) => {
                                            await this.setState({
                                                ...this.state, filters: {
                                                    ...this.state.filters, data_cadastro_empreendimento_menor_que: e
                                                }
                                            });
                                        }}
                                    />
                                </div>
                            </div>


                            <div className="form-group row">
                                <div className="col-12 col-md-4 col-sm-4">
                                    <button className="btn btn-block btn-sm btn-success" onClick={async () => {
                                        await this.setState({
                                            ...this.state, pagination: {
                                                ...this.state.pagination, current_page: 1
                                            }
                                        });

                                        await this.getResultsCidade();
                                    }}>
                                        Pesquisar &nbsp;
                                        <i className="fa fa-search"></i>
                                    </button>
                                </div>

                                <div className="col-12 col-md-4 col-sm-4">
                                    <button className="btn btn-block btn-sm btn-secondary" onClick={async () => {
                                        await this.setState({
                                            ...this.state,
                                            filters: {
                                                ...this.state.filters,
                                                export_excel: true,
                                            },
                                            pagination: {
                                                ...this.state.pagination, current_page: 1
                                            }
                                        });

                                        await this.getResultsCidade();
                                    }}>
                                        Exportar Excel &nbsp;
                                        <i className="fa fa-file-excel-o"></i>

                                    </button>
                                </div>

                                <div className="col-12 col-md-4 col-sm-4">
                                    <button className="btn btn-block btn-sm btn-danger" onClick={this.clearFilters}>
                                        Limpar Filtros &nbsp;
                                        <i className="fa fa-file"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Panel>
                </div>
            </div>

            <div className="row" style={{ marginTop: '25px' }}>
                <div className="col-12">
                    <ListaResultadosColetados
                        coletas={this.state.resultados}
                        loading={this.state.loading}
                        cadastrarEmpreendimento={this.cadastrarEmpreendimento}
                        setLoading={this.setLoading}
                        showModalIgnorarColeta={this.showModalIgnorarColeta}
                        ignorados={this.state.ignorados}
                        pagination={this.state.pagination}
                        handlePageChange={this.handlePageChange}
                        handlePerPageChanged={this.handlePerPageChanged}
                        openBuscaEmpreendimentoComFiltros={this.openBuscaEmpreendimentoComFiltros}
                    />
                </div>
            </div>
        </React.Fragment>)
    }
}

if (document.getElementById('js-coleta-automatizada-resultados-cidade')) {
    ReactDOM.render(<ResultadosCidade />, document.getElementById('js-coleta-automatizada-resultados-cidade'))
}

